<template>
    <b-badge v-if="entry"
             :variant="badgeVariant"
             :class="[size === 'lg' ? 'badge-lg' : '', pill ? 'badge-pill' : '']">
        <feather-icon v-if="entry.icon" :icon="entry.icon" size="12" class="mr-3"></feather-icon>
        {{ entry.label || entry.text }}
    </b-badge>
</template>

<script>
    /*
     * Renders one badge from a status map, e.g.
     *   <StatusBadge :value="item.status" :map="{ 0: { label: 'Kladde', variant: 'secondary' }, 1: { label: 'Sendt', variant: 'info' } }" />
     *
     * Also accepts the store's `taskStatus` / `meetingStatus` shaped maps ({ text, class }).
     */
    export default {
        props: {
            value: {
                type: [String, Number, Boolean],
                default: null
            },
            map: {
                type: [Object, Array],
                default: () => ({})
            },
            size: {
                type: String,
                default: 'md'
            },
            pill: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            entry() {
                if (this.value === null || this.value === undefined) {
                    return null
                }
                var entry = this.map[this.value]
                if (!entry && Array.isArray(this.map)) {
                    entry = this.map.find(x => x.value == this.value)
                }
                return entry || null
            },
            badgeVariant() {
                var variant = this.entry.variant

                if (!variant && this.entry.class) {
                    // store maps use text-* classes → derive the variant
                    var match = /text-([a-z]+)/.exec(this.entry.class)
                    variant = match ? match[1] : 'secondary'
                }

                variant = variant || 'secondary'

                if (this.light && variant.indexOf('light-') !== 0) {
                    return 'light-' + variant
                }
                return variant
            }
        }
    }
</script>

<style lang="scss" scoped>
    .badge-lg {
        font-size: 0.95rem;
        padding: 0.5rem 0.75rem;
    }
</style>
